import api from "./api";
import logger from "../utils/logger";

const paymentService = {
  /**
   * Get all payment methods for the authenticated user
   * @returns {Promise<Array>} Array of payment methods
   */
  getPaymentMethods: async () => {
    try {
      const response = await api.get("/users/payment-method");
      return response.data.paymentMethods;
    } catch (error) {
      logger.error("Error fetching payment methods", error);
      throw error;
    }
  },

  /**
   * Add a new payment method
   * @param {string} paymentMethodId - Stripe payment method ID
   * @returns {Promise<Array>} Updated array of payment methods
   */
  addPaymentMethod: async (paymentMethodId) => {
    try {
      const response = await api.post("/users/payment-method", {
        paymentMethodId,
      });
      return response.data.paymentMethods;
    } catch (error) {
      logger.error("Error adding payment method", error);
      throw error;
    }
  },

  /**
   * Delete a payment method
   * @param {string} paymentMethodId - Payment method ID to delete
   * @returns {Promise<void>}
   */
  deletePaymentMethod: async (paymentMethodId) => {
    try {
      await api.delete(`/users/payment-method/${paymentMethodId}`);
    } catch (error) {
      logger.error("Error deleting payment method", error);
      throw error;
    }
  },

  /**
   * Set default payment method
   * @param {string} paymentMethodId - Payment method ID to set as default
   * @returns {Promise<void>}
   */
  setDefaultPaymentMethod: async (paymentMethodId) => {
    try {
      await api.put(`/users/payment-method/${paymentMethodId}/default`);
    } catch (error) {
      logger.error("Error setting default payment method", error);
      throw error;
    }
  },

  /**
   * Create a setup intent for saving a payment method
   * @returns {Promise<string>} Client secret
   */
  createSetupIntent: async () => {
    try {
      const response = await api.post("/users/payment-method/setup");
      return response.data.clientSecret;
    } catch (error) {
      logger.error("Error creating setup intent", error);
      throw error;
    }
  },
};

export default paymentService;
